import LocalImages from "assets/images/local-images";
import Content, { ContentNS } from "content/content";
import ConfirmButton from "features/shared/components/buttons/ConfirmButton.styled";
import useGeneralAnalytics from "features/shared/hooks/analytics/useGeneralAnalytics";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import { FC, useEffect } from "react";
import NativeBridge from "services/native-bridge/native-bridge";
import { useAppStore } from "store/store";

// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import NotFoundContainer from "./styles/NotFoundContainer-APP_CLIENT.styled";

const NotFound: FC = () => {
  useAppStore((state) => state.locale);
  useGeneralAnalytics();

  const title = Content.shared.t("not-found.title", { ns: ContentNS.ui });
  const description = Content.shared.t("not-found.description", {
    ns: ContentNS.ui,
  });
  const linkTitle = Content.shared.t("not-found-button", { ns: ContentNS.ui });
  const returnUrl = useAppStore((state) => state.returnUrl);

  useEffect(() => {
    NativeBridge.shared.closeFlow("not_found");
  }, []);

  return (
    <NotFoundContainer>
      <img
        alt="not found icon"
        src={LocalImages.shared.images.icons.notFound}
      />
      {title ? <TertiaryHeader>{title}</TertiaryHeader> : null}
      <Summary>{description}</Summary>
      {returnUrl !== null && !NativeBridge.shared.isEmbedded ? (
        <a href={returnUrl}>
          <ConfirmButton>{linkTitle}</ConfirmButton>
        </a>
      ) : null}
    </NotFoundContainer>
  );
};

export default NotFound;
